import { getEnv } from '@/constants';
import loggerService from '@/services/logger.service';

export function deleteAllCookies() {
  document.cookie.split(';').forEach(function (c) {
    if (c.includes('preProd') || c.includes('build_number')) {
      return;
    }
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
}

export function clearAllTokensFromLocalStorage() {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.includes('CognitoIdentityServiceProvider') || key.includes('gcauth_') || key.includes('event_app_')) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    loggerService.warn('error in clearAllTokensFromLocalStorage', error);
  }
}

export function deleteWrongCognitoDomainCookies(poolId: string) {
  const domain = getEnv('VUE_APP_AUTH_COOKIE_DOMAIN');
  const cookieBaseDomain = getEnv('VUE_APP_COOKIE_BASE_DOMAIN');
  if (domain === cookieBaseDomain) {
    return;
  }
  document.cookie.split(';').forEach(function (c) {
    if (c.includes(poolId)) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};domain=${cookieBaseDomain};path=/`);
    }
  });
}

export function removeTokensByPattern(pattern: string) {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.includes(pattern)) {
        localStorage.removeItem(key);
      }
    });
  } catch (error) {
    loggerService.warn('error in removeTokensByPattern', error);
  }
}
